﻿import OrderFilmApi from '../../OrderFilmApi';

export function sendLinks(orderId: number, email: string, links: string[]): Promise<void> {
    return OrderFilmApi.sendLinks(orderId, email, links);
}
